import SplitScreenContent from "../../components/SplitScreenContent";

export const verkauf = {
  title: "Porsche verkaufen im Kundenauftrag – stressfrei & professionell",
  titleImageUrl: "porsche-engine.jpg",
  theme: "dark",
  meta: {
    title:
      "Porsche verkaufen im Kundenauftrag – Consignment & Kommission | WTM Sportwagen",
    description:
      "Porsche seriös verkaufen: Wertermittlung, sichere Einlagerung, Aufbereitung & Detailing, Profi-Fotos & Videos, Inserate auf mobile.de & eigener Plattform, Netzwerk-Marketing, Interessenten-Management, Verhandlung & Abschluss – alles aus einer Hand.",
  },

  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323486/gallery/frank_kayser/M10_7409_q5qdyx.jpg",
      headline: "Verkaufen ohne Stress. Zum richtigen Preis.",
      // description:
      //   "Ein Porsche ist mehr als ein Fahrzeug – er ist ein Kapitel Lebensgeschichte. Wenn es Zeit ist, ihn weiterzugeben, begleiten wir Sie persönlich und professionell. Sie behalten die Kontrolle, wir übernehmen den Aufwand.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },
    {
      type: "text_section_hero",
      // headline: "Verkaufen ohne Stress. Zum richtigen Preis.",
      lead: "Ein Porsche ist mehr als ein Fahrzeug – er ist ein Kapitel Lebensgeschichte. Wenn es Zeit ist, ihn weiterzugeben, begleiten wir Sie persönlich und professionell. Sie behalten die Kontrolle, wir übernehmen den Aufwand.",
      highlight:
        "End-to-end: Bewertung, Vermarktung, Abschluss – wir kümmern uns.",
      spacing: "comfortable",
      size: "lg",
      variant: "primary",
      margin: false,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6857_dfxr38",
      headline: "Porsche verkaufen bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Wir übernehmen den kompletten Prozess"
          intro="Sie wollen Ihren Porsche verkaufen, aber nicht mit Zeitverschwendern, Besichtigungstouristen und endlosen Verhandlungen kämpfen? Wir verkaufen Ihren Porsche im Kundenauftrag – Sie bleiben entspannt, wir kümmern uns um alles."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Keine Besichtigungstouristen mehr",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Schluss mit endlosen Telefonaten, verpassten Terminen und Leuten, die nur schauen wollen. Wir qualifizieren jeden Interessenten vorab und begleiten alle Besichtigungen persönlich.",
            },
            {
              type: "heading",
              text: "Professionelle Verhandlungsführung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wir verhandeln in Ihrem Namen und sorgen für den bestmöglichen Preis. Sie legen den Mindestpreis fest – wir holen das Maximum heraus, ohne dass Sie sich ärgern müssen.",
            },
            {
              type: "heading",
              text: "Sichere Abwicklung garantiert",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von der Wertermittlung über sichere Einlagerung bis zur rechtssicheren Übergabe – wir übernehmen den gesamten Prozess. Sie bekommen Ihr Geld, ohne Risiko und Aufwand.",
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Porsche stressfrei verkaufen – jetzt starten",
                paragraph:
                  "Teilen Sie uns kurz Modell, Laufleistung und Historie mit. Wir melden uns persönlich und übernehmen den gesamten Verkaufsprozess für Sie.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Porsche Verkauf - Stressfrei und professionell",
      navbarHeight: 0,
    },

    // {
    //   type: "lighthouse-grid",
    //   variant: "secondary",
    //   spacing: "comfortable_top_spacious_bottom",
    //   maxWidth: "none",
    //   showHeader: true,
    //   stickyHeadline: "Porsche Verkauf bei WTM",
    //   title: "Gallerie",
    //   subtitle: "Professioneller Verkaufsservice",
    //   description:
    //     "Von der ersten Bewertung bis zur finalen Übergabe – wir übernehmen den gesamten Verkaufsprozess für Sie. Professionell, stressfrei und mit dem Ziel, den bestmöglichen Preis zu erzielen.",
    //   navbarHeight: 0,
    //   images: [
    //     {
    //       src: "gallery/frank_kayser/M10_7409_q5qdyx",
    //       alt: "WTM Sportwagen - Porsche Verkaufsberatung",
    //     },
    //     {
    //       src: "gallery/frank_kayser/M10_6890_ztzlfu",
    //       alt: "WTM Sportwagen - Porsche Aufbereitung für Verkauf",
    //     },
    //     {
    //       src: "gallery/frank_kayser/M10_6886_1_bchwnz",
    //       alt: "WTM Sportwagen - Porsche Verkaufspräsentation",
    //     },
    //     {
    //       src: "gallery/frank_kayser/M10_6915_wexceu",
    //       alt: "WTM Sportwagen - Porsche Verkaufsabwicklung",
    //     },
    //     {
    //       src: "gallery/frank_kayser/M10_6882_bvftmt",
    //       alt: "WTM Sportwagen - Porsche Verkaufsservice",
    //     },
    //     {
    //       src: "gallery/frank_kayser/L1013411_2_xh5gzj",
    //       alt: "WTM Sportwagen - Porsche Verkaufserfolg",
    //     },
    //   ],
    //   imageWidth: 800,
    //   imageCrop: "fill",
    //   imageGravity: "center",
    //   highQuality: true,
    //   showThumbnails: true,
    // },

    // {
    //   type: "cta-with-modal",
    //   headline: "Unverbindlich Verkaufswert ermitteln",
    //   paragraph:
    //     "Sie überlegen, Ihren Porsche zu verkaufen? Wir erstellen Ihnen eine kostenlose und realistische Marktbewertung – ohne Verpflichtung.",
    //   darkMode: true,
    //   spacing: "comfortable_top_tight_bottom",
    // },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_6922_2_w7yd9v",
      headline: "So einfach läuft's ab",
      rightContent: (
        <SplitScreenContent
          headline="Vier Schritte zum entspannten Verkauf"
          intro="Klarer Prozess, klare Zuständigkeiten – Sie sind jederzeit informiert, müssen sich aber um nichts kümmern. Von der ersten Bewertung bis zur finalen Übergabe übernehmen wir alles."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "1. Bewertung & Einlagerung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wir inspizieren Ihr Fahrzeug, analysieren Historie und Marktsituation und erstellen eine realistische Preisempfehlung. Danach lagern wir Ihren Porsche sicher und versichert bei uns ein.",
            },
            {
              type: "heading",
              text: "2. Aufbereitung & Präsentation",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Professionelles Detailing, hochwertige Fotos und Videos, sowie ein überzeugendes Exposé – wir sorgen dafür, dass Ihr Porsche perfekt präsentiert wird.",
            },
            {
              type: "heading",
              text: "3. Vermarktung & Interessenten",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Inserate auf mobile.de und unserer Plattform, plus aktives Netzwerk-Marketing. Wir qualifizieren alle Interessenten und begleiten jede Besichtigung persönlich.",
            },
            {
              type: "heading",
              text: "4. Verhandlung & Abschluss",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wir verhandeln für Sie den bestmöglichen Preis, wickeln den Kaufvertrag rechtssicher ab und sorgen für eine sichere Zahlung. Sie bekommen Ihr Geld – wir den Aufwand.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Was wir für Sie übernehmen",
                items: [
                  "Realistische Markt- & Preisbewertung auf Basis Zustand/Historie",
                  "Sichere, versicherte Einlagerung – diskret & trocken",
                  "Professionelle Aufbereitung und hochwertige Media-Produktion",
                  "Interessenten-Qualifizierung und Verhandlungsführung",
                  "Rechtssichere Abwicklung mit Treuhand-Service",
                ],
                highlightedIndices: [0, 1, 2, 3, 4],
                icon: "check",
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Verkaufsprozess - Einfach und stressfrei",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/M10_7421_1_yriw6h",
      headline: "Für alle Porsche-Modelle geeignet",
      rightContent: (
        <SplitScreenContent
          headline="Wir verkaufen alle Porsche-Modelle"
          intro="Vom luftgekühlten Klassiker bis zum modernen GT – wir kennen die Zielgruppe und ihren Anspruch. Als spezialisierte Porsche-Werkstatt erreichen wir genau die richtigen Käufer für Ihr Fahrzeug."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Luftgekühlte Klassiker",
              level: 3,
            },
            {
              type: "paragraph",
              text: "911 F- & G-Modell, 964, 993 – diese Fahrzeuge sind besonders gefragt. Wir kennen die Sammler und Liebhaber, die bereit sind, den richtigen Preis zu zahlen.",
            },
            {
              type: "heading",
              text: "Moderne Porsche",
              level: 3,
            },
            {
              type: "paragraph",
              text: "996, 997, 991 (Carrera, Turbo, GT-Modelle), Boxster & Cayman – auch moderne Porsche verkaufen wir erfolgreich an die richtige Zielgruppe.",
            },
            {
              type: "heading",
              text: "SUV & Limousinen",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Cayenne, Macan, Panamera – alle Baureihen. Auch Sonderfahrzeuge, Backdates und trackfokussierte Umbauten finden bei uns den richtigen Abnehmer.",
            },
            {
              type: "heading",
              text: "Unser Ziel: Der richtige Käufer zum richtigen Preis",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Mit maximaler Transparenz und minimalem Aufwand für Sie. Sie entscheiden über den Mindestpreis – wir sorgen für den bestmöglichen Verkaufserfolg.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum WTM als Verkaufspartner?",
                items: [
                  "Spezialisierte Porsche-Werkstatt mit passender Zielgruppe",
                  "Aktives Netzwerk aus Sammlern, Liebhabern und Händlern",
                  "Professionelle Präsentation auf mobile.de und eigener Plattform",
                  "Persönliche Betreuung von der Bewertung bis zur Übergabe",
                  "Rechtssichere Abwicklung mit Treuhand-Service",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline:
                  "Jetzt Porsche verkaufen lassen – stressfrei & professionell",
                paragraph:
                  "Teilen Sie uns kurz Modell, Laufleistung und Historie mit. Wir melden uns persönlich und übernehmen den gesamten Verkaufsprozess für Sie.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen - Porsche Verkauf für alle Modelle",
      navbarHeight: 0,
    },

    {
      type: "relevant-posts",
      postSlugs: [
        "porsche-kaufberatung",
        
      ],
      headline: "Werkstatt Journal: Verkauf & Werterhalt",
      darkMode: false,
    },
  ],
};
